import { render, staticRenderFns } from "./CatalogCard.vue?vue&type=template&id=331f8b4a&scoped=true&lang=pug"
import script from "./CatalogCard.vue?vue&type=script&lang=js"
export * from "./CatalogCard.vue?vue&type=script&lang=js"
import style0 from "./CatalogCard.vue?vue&type=style&index=0&id=331f8b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f8b4a",
  null
  
)

export default component.exports